module.exports = __webpack_public_path__ + "img/引入.7d549bbd.svg";